export type DateInput = string | number | Date | null | undefined;

const DEFAULT_LOCALE = "ru";

function resolveLocale(locale: string | null | undefined): string {
  return (locale || DEFAULT_LOCALE).toLowerCase();
}

function isEnglishLocale(locale: string): boolean {
  return locale.startsWith("en");
}

function parseDate(input: DateInput): Date | null {
  if (!input) return null;
  const date = input instanceof Date ? input : new Date(input);
  if (Number.isNaN(date.getTime())) return null;
  return date;
}

function pad2(value: number): string {
  return String(value).padStart(2, "0");
}

export function formatDate(input: DateInput, locale?: string): string {
  const date = parseDate(input);
  if (!date) return "";

  const day = pad2(date.getDate());
  const month = pad2(date.getMonth() + 1);
  const year = String(date.getFullYear());

  return isEnglishLocale(resolveLocale(locale))
    ? `${month}/${day}/${year}`
    : `${day}/${month}/${year}`;
}

export function formatTime(
  input: DateInput,
  locale?: string,
  options?: { withSeconds?: boolean }
): string {
  const date = parseDate(input);
  if (!date) return "";

  return new Intl.DateTimeFormat(locale ?? DEFAULT_LOCALE, {
    hour: "2-digit",
    minute: "2-digit",
    ...(options?.withSeconds ? { second: "2-digit" } : {}),
  }).format(date);
}

export function formatDateTime(
  input: DateInput,
  locale?: string,
  options?: { withSeconds?: boolean }
): string {
  const datePart = formatDate(input, locale);
  const timePart = formatTime(input, locale, options);

  if (!datePart && !timePart) return "";
  if (!timePart) return datePart;
  if (!datePart) return timePart;
  return `${datePart} ${timePart}`;
}
